import React from 'react';
import { isEmpty } from 'lodash';

import TireListRow from './TireListRow';
import Meisterkachel from '../../components/Meisterkachel/Meisterkachel';

const TireList = ({ filteredTires = [] }) => {
    if (isEmpty(filteredTires)) {
        return <Meisterkachel />;
    }

    return (
        <div className="uk-grid uk-grid-small uk-child-width-1-1@m" data-uk-grid="">
            {filteredTires.map((tire, i) => (
                <div key={tire?._id ?? i}>
                    <TireListRow tire={tire} />
                </div>
            ))}
        </div>
    );
};

export default TireList;
